export const config = {
    base: "https://reinvb.be",
    pocketbase: "https://reinvb.be/backend"
};
